import React, { Component } from 'react';
import Glider from 'react-glider';
import Image from 'next/image';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import config from '~/config';
import { slugs } from '~/utils';
import { SERVICE_TYPES } from '~/utils/constants';
import IconLeft from '~/components/svg/icon-left.svg';
import IconRight from '~/components/svg/icon-right.svg';
import themeVariables from '~/shared/themeVariables';
import IconLeftScroll from '~/components/svg/download-page/button-left-category.svg';
import IconRightScroll from '~/components/svg/download-page/button-right-category.svg';

@withI18next()
class SliderSimilar extends Component {
  state = {
    currentSlide: 0,
  };
  gliderRef = React.createRef();

  rendeMainSimilarUrl = (item, lang) => {
    let url = `/${config.detailPagePath[config.serviceType]}/${item.id}`;
    const photoTitle = config.getTitleByLanguage(item.title, lang);

    if (photoTitle) {
      const slugTitle = slugs.makeSlug(photoTitle, { lang });
      url = `${url}/${slugTitle}`;
    }

    return url;
  };

  handleSlideLeft = () => {
    if (this.gliderRef.current && this.state.currentSlide > 0) {
      this.setState(
        {
          currentSlide: this.state.currentSlide - 1,
        },
        () => this.gliderRef.current.scrollItem(this.state.currentSlide, true),
      );
    }
  };

  handleSlideRight = (evt) => {
    evt.stopPropagation();
    if (this.gliderRef.current && this.gliderRef.current.ele) {
      const {
        offsetWidth,
        scrollLeft,
        scrollWidth,
      } = this.gliderRef.current.ele;
      if (offsetWidth + scrollLeft >= scrollWidth) {
        this.setState(
          {
            currentSlide: 0,
          },
          () =>
            this.gliderRef.current.scrollItem(this.state.currentSlide, true),
        );
        return;
      }
      this.setState(
        {
          currentSlide: this.state.currentSlide + 1,
        },
        () => this.gliderRef.current.scrollItem(this.state.currentSlide, true),
      );
    }
  };

  renderSimilarUrl = (domainService, detailPath, item) => {
    const { lng } = this.props;

    let url = '';
    const photoTitle = config.getTitleByLanguage(item.title, lng);

    url = `/${detailPath}/${item.id}`;
    if (photoTitle) {
      const slugTitle = slugs.makeSlug(photoTitle, { lang: lng });
      url = `/${detailPath}/${item.id}/${slugTitle}`;
    }

    return url;
  };

  render() {
    const gliderSettings = {
      className: 'slider-related-wrapper',
      hasArrows: true,
      skipTrack: true,
      slidesToShow: 1,
      draggable: true,
      iconLeft: (
        <div
          className="chevron-container-mobile left"
          onClick={this.handleSlideLeft}
        >
          {/* <IconLeft
            style={{ height: 24 }}
            onClick={() =>
              this.setState({
                openStandardLicenseForm: !this.state.openStandardLicenseForm,
              })
            }
          /> */}
          <img
            data-src={`${config.staticPrefix}/static/assets/icon-homepage/button-left-category.svg`}
            className="lazyload button-category left"
            alt="go left"
            onClick={() =>
              this.setState({
                openStandardLicenseForm: !this.state.openStandardLicenseForm,
              })
            }
            width={47}
            height={47}
          />
          {/* <div className="button-category left">
            <IconLeftScroll />
          </div> */}
        </div>
      ),
      iconRight: (
        <div
          className="chevron-container-mobile right"
          onClick={this.handleSlideRight}
        >
          {/* <IconRight
            style={{ height: 24 }}
            onClick={() =>
              this.setState({
                openStandardLicenseForm: !this.state.openStandardLicenseForm,
              })
            }
          /> */}
          <img
            data-src={`${config.staticPrefix}/static/assets/icon-homepage/button-right-category.svg`}
            className="lazyload button-category left"
            alt="go left"
            onClick={() =>
              this.setState({
                openStandardLicenseForm: !this.state.openStandardLicenseForm,
              })
            }
            width={47}
            height={47}
          />
        </div>
      ),
    };

    const { images, lng, isMain, domainService, detailPath } = this.props;
    const serviceType = this.props.serviceType || config.serviceType;

    const imageWrapperStyle = {
      width: 'fit-content',
      height: 100,
      overflow: 'hidden',
      display: 'flex',
      margin: '4px 4px',
      position: 'relative',
    };
    if (
      serviceType === SERVICE_TYPES.ILLUST_AC ||
      serviceType === SERVICE_TYPES.SILHOUETTE_AC
    ) {
      // imageWrapperStyle.background = '#fff';
      // imageWrapperStyle.padding = 4;
      imageWrapperStyle.borderRadius = 2;
      imageWrapperStyle.boxShadow = '0 2px 4px 0 rgb(0 0 0 / 20%)';
    }

    return (
      <div className={`similar-image ${config.serviceType}-similar-image`}>
        <Glider ref={this.gliderRef} {...gliderSettings}>
          <div className="placeholder"></div>
          {images.map((item) => {
            let width, height;
            width = height = 1000;
            if (item.meta_data) {
              width = item.meta_data.width || 1;
              height = item.meta_data.height || 1;
            }
            const imgHeight = 100;
            const imgWidth = (width * imgHeight) / height;
            const photoTitle = config.getTitleByLanguage(item.title, lng);
            return (
              <figure key={item.id} className="image-related-container">
                {isMain ? (
                  <I18nLink
                    prefetch={false}
                    href={this.rendeMainSimilarUrl(item, lng)}
                  >
                    <a>
                      <div style={imageWrapperStyle}>
                        {/* <img
                          className="lazyload slider-similar-image"
                          data-src={item.thumbnail}
                          alt={photoTitle}
                          width={imgWidth}
                          height={imgHeight}
                        /> */}
                        <Image
                          className="slider-similar-image"
                          src={item.thumbnail}
                          alt={photoTitle}
                          layout="fixed"
                          objectFit="contain"
                          width={imgWidth}
                          height={imgHeight}
                        />
                        <div className="background-hover-similar"></div>
                      </div>
                    </a>
                  </I18nLink>
                ) : (
                  <I18nLink
                    prefetch={false}
                    host={domainService}
                    href={this.renderSimilarUrl(
                      domainService,
                      detailPath,
                      item,
                      lng,
                    )}
                  >
                    <a target="_blank">
                      <div style={imageWrapperStyle}>
                        {/* <img
                          className="slider-similar-image"
                          src={item.thumbnail}
                          alt={photoTitle}
                          width={imgWidth}
                          height={imgHeight}
                        /> */}
                        <Image
                          className="lazyload slider-similar-image"
                          src={item.thumbnail}
                          alt={photoTitle}
                          layout="fixed"
                          objectFit="contain"
                          width={imgWidth}
                          height={imgHeight}
                        />
                      </div>
                    </a>
                  </I18nLink>
                )}
              </figure>
            );
          })}
        </Glider>
        <style jsx>
          {`
            .placeholder {
              visibility: hidden;
              display: none;
            }
            .image-related-container {
              filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5));
            }
          `}
        </style>
        <style jsx global>
          {`
            .chevron-container-mobile {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              position: absolute;
            }
            .chevron-container-mobile.left {
              left: 44px;
              z-index: 999;
            }
            .chevron-container-mobile.right {
              right: 44px;
            }
            .slider-related-wrapper {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 120px;
            }

            .similar-image .glider-next,
            .similar-image .glider-prev {
              top: calc(50% - 22px);
            }

            .similar-image .glider-next.disabled,
            .similar-image .glider-prev.disabled {
              opacity: 1;
            }

            .lazyload:not([src]) {
              visibility: hidden;
            }
            .background-hover-similar {
              width: 100%;
              height: 100%;
              position: absolute;
              filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.25));
            }
            .background-hover-similar:hover {
              background: linear-gradient(
                  0deg,
                  rgba(0, 0, 0, 0.2),
                  rgba(0, 0, 0, 0.2)
                ),
                url(66121_s.jpg);
            }
            @media only screen and (max-width: ${themeVariables.breakpoints
                .tabletS.maxWidth}px) {
              .slider-related-wrapper {
                width: 100%;
                margin: 0px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default SliderSimilar;
